import { useEffect, useState } from 'react'
import { normalizeAccessoryPhotoDisplayUrl } from '@/lib/normalizeAccessoryPhoto'

type Props = {
  src: string
  alt: string
  className?: string
  style?: React.CSSProperties
}

/**
 * Один слой пикселей #FFF (canvas → blob). Не показываем сырой JPG до обработки — иначе на iOS виден «ящик».
 */
export function AccessoryPhotoOnWhite({ src, alt, className, style }: Props) {
  const [displaySrc, setDisplaySrc] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    setDisplaySrc(null)
    if (!src) return

    void normalizeAccessoryPhotoDisplayUrl(src).then((normalized) => {
      if (!cancelled) setDisplaySrc(normalized || src)
    })

    return () => {
      cancelled = true
    }
  }, [src])

  if (!src) return null

  return (
    <div
      className="flex items-center justify-center w-full h-full"
      style={{ background: '#ffffff' }}
    >
      {displaySrc ? (
        <img
          src={displaySrc}
          alt={alt}
          className={className}
          style={{ background: '#ffffff', display: 'block', ...style }}
          decoding="async"
          loading="eager"
        />
      ) : (
        <div
          className={className}
          style={{ ...style, background: '#ffffff', minHeight: '4rem' }}
          aria-hidden
        />
      )}
    </div>
  )
}
